import React from 'react'

import {
  Switch,
  Route
} from 'react-router-dom'

import MessagesContainer from 'components/messages-container/messages-container.component'

const Tips = () => {
  return (
    <Switch>
      <Route path='/messages/:id'>
        <MessagesContainer />
      </Route>
    </Switch>
  )
}

export default Tips
